/* global $ */
import React, { Component } from 'react';

export class LanguageSwitcher extends Component {
    componentDidMount() {
        $(this.refs.lang).dropdown();
    }

    render() {
        return (
            <select id="langSwitcher" name="lang" ref="lang" defaultValue={this.props.lang} className="ui compact selection dropdown inverted" onChange={this.props.changeLang.bind(this)} value={this.props.lang}>
                <option value="en">EN</option>
                <option value="nl">NL</option>
                <option value="fr">FR</option>
            </select>
        )
    };
}


// WEBPACK FOOTER //
// ./src/components/LanguageSwitcher.jsx